import { FC } from 'react';
import { Text } from '@weave/design-system';
import { Category } from '@forms-exp/types';
import CategorizedChecklist from './categorized-checklist/categorized-checklist.component';
import { DEFAULT_CATEGORIES } from './categorized-checklist-field.constant';

interface CategorizedChecklistFieldProps {
  fieldProps: any; // TODO: Add proper type
  categories: Category[] | undefined;
  label: string;
  onUpdateValue: () => void;
}

export const CategorizedChecklistField: FC<CategorizedChecklistFieldProps> = ({
  categories = DEFAULT_CATEGORIES,
  fieldProps,
  label,
  onUpdateValue,
}) => {
  return (
    <div>
      <Text weight="regular">{label}</Text>
      {categories.map((category) => (
        <CategorizedChecklist
          key={category.id}
          category={category}
          fieldProps={fieldProps}
          onUpdateValue={onUpdateValue}
        />
      ))}
    </div>
  );
};
